import React from 'react';
import { Button } from './ui/Button';
import { ArrowRight, Wand2 } from 'lucide-react';
export function Hero() {
  return <section id="hero" className="relative pt-32 pb-20 lg:pt-48 lg:pb-32 overflow-hidden" data-id="element-107">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-108">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-center" data-id="element-109">
          {/* Text Content */}
          <div className="max-w-2xl" data-id="element-110">
            <div className="chrome-badge inline-flex items-center gap-2 px-5 py-2 rounded-full text-sm font-bold text-neutral-900 mb-8" data-id="element-111">
              <Wand2 className="w-4 h-4" data-id="element-112" />
              <span className="relative z-10" data-id="element-113">KI-gestützte Visualisierung</span>
            </div>
            <h1 className="text-5xl sm:text-6xl lg:text-7xl font-semibold tracking-tight text-black leading-[1.1] mb-8" data-id="element-114">
              Immobilien sehen, bevor sie fertig sind
            </h1>
            <p className="text-xl font-light text-neutral-500 leading-relaxed mb-10 max-w-lg" data-id="element-115">
              Hyperrealistische KI-Visualisierungen für Homestaging, Fassaden
              und Vermarktung – schnell, skalierbar, premium.
            </p>
            <div className="flex flex-col sm:flex-row gap-4" data-id="element-116">
              <Button size="lg" onClick={() => document.getElementById('contact')?.scrollIntoView({
              behavior: 'smooth'
            })} data-id="element-117">
                Projekt anfragen
                <ArrowRight className="ml-2 h-5 w-5" data-id="element-118" />
              </Button>
              <Button variant="secondary" size="lg" onClick={() => document.getElementById('gallery')?.scrollIntoView({
              behavior: 'smooth'
            })} data-id="element-119">
                Beispiele ansehen
              </Button>
            </div>
          </div>

          {/* Hero Visual with Animated Gradient Border */}
          <div className="relative lg:h-[600px] w-full" data-id="element-120">
            <div className="animated-gradient-border h-full" data-id="element-121">
              <div className="animated-gradient-border-inner overflow-hidden" data-id="element-122">
                <div className="w-full h-full relative min-h-[400px] lg:min-h-0" data-id="element-123">
                  <video className="absolute inset-0 w-full h-full object-cover grayscale-[20%] transition-transform duration-700 ease-out hover:scale-105" autoPlay loop muted playsInline poster="https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?q=80&w=2653&auto=format&fit=crop" data-id="element-124">
                    <source src="https://cdn.magicpatterns.com/uploads/2H6oJmPAd4GMBHTXVHpQ54/20260127_1620_New Video_simple_compose_01kg00medpfxbay14fejc2rk38.mp4" type="video/mp4" data-id="element-125" />
                    Your browser does not support the video tag.
                  </video>
                  <div className="absolute inset-0 bg-gradient-to-t from-white via-transparent to-transparent" data-id="element-126"></div>

                  {/* Floating Badge */}
                  <div className="absolute bottom-8 left-8 bg-white border border-neutral-200 px-6 py-4 rounded-lg shadow-sm" data-id="element-127">
                    <p className="text-xs font-medium text-neutral-400 uppercase tracking-wider mb-1" data-id="element-128">
                      Rendering Preview
                    </p>
                    <p className="text-sm font-medium text-black" data-id="element-129">
                      Villa K, München
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}